export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  image: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: '1',
    slug: 'wanghong-heiliao',
    name: '网红黑料',
    description: '揭秘各大网红不为人知的另一面，反差视频、私下行为大曝光，让你看清荧幕背后的真相。',
    icon: 'ri-spy-line',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20silhouette%20of%20influencer%20with%20phone%20screen%20glow%20on%20face%2C%20dramatic%20split%20personality%20concept%2C%20one%20side%20bright%20and%20glamorous%20other%20side%20dark%20and%20hidden%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20noir%20photography%2C%20deep%20shadows%2C%20clean%20dark%20background%2C%20mysterious%20mood&width=1920&height=600&seq=category-wanghong&orientation=landscape',
    count: 4,
  },
  {
    id: '2',
    slug: 'mingxing-liaotian',
    name: '明星聊天记录',
    description: '明星私下聊天记录、暧昧对话泄露，娱乐圈真实人际关系大起底，吃瓜第一现场。',
    icon: 'ri-chat-smile-2-line',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20phone%20screens%20floating%20in%20dark%20space%20showing%20chat%20interfaces%2C%20dramatic%20red%20notification%20glow%2C%20privacy%20breach%20concept%2C%20digital%20secrets%20exposed%2C%20cyberpunk%20aesthetic%2C%20dark%20background%20with%20glowing%20accents%2C%20mysterious%20atmosphere%2C%20cinematic%20composition&width=1920&height=600&seq=category-chat&orientation=landscape',
    count: 3,
  },
  {
    id: '3',
    slug: 'bozhu-baoliao',
    name: '博主私下爆料',
    description: '圈内博主亲身经历、行业黑幕揭秘，来自第一线的真实爆料，让你看到镜头之外的真相。',
    icon: 'ri-megaphone-line',
    image: 'https://readdy.ai/api/search-image?query=Anonymous%20figure%20holding%20megaphone%20in%20dark%20alley%2C%20dramatic%20backlight%20from%20streetlamp%2C%20whistleblower%20concept%2C%20mysterious%20urban%20night%20scene%2C%20cinematic%20noir%20photography%2C%20red%20accent%20light%2C%20deep%20shadows%2C%20clean%20dark%20background%2C%20brave%20revelation%20mood&width=1920&height=600&seq=category-whistleblower&orientation=landscape',
    count: 3,
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => categories.find((c) => c.slug === slug);